import { render, staticRenderFns } from "./CountryTextBlock.vue?vue&type=template&id=48801fc8&scoped=true"
import script from "./CountryTextBlock.vue?vue&type=script&lang=js"
export * from "./CountryTextBlock.vue?vue&type=script&lang=js"
import style0 from "./CountryTextBlock.vue?vue&type=style&index=0&id=48801fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48801fc8",
  null
  
)

export default component.exports